import React from "react";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuSurface from "../ui/MenuSurface";
import SleeveLabelPrinting from "./SleeveLabelPrinting";
import useLabelPrinting from "../hooks/useLabelPrinting";

export default function AlbumOptionsMenu({
  albumId,
  username,
  canPrintLabel,
  open,
  onToggle,
  onClose,
  disabled,
  menuRef,
  children,
  bulkEditAction,
}) {
  const [anchor, setAnchor] = React.useState(null);
  const printing = useLabelPrinting(albumId, username);
  React.useEffect(() => {
    if (printing.open && open) onClose();
  }, [printing.open, open, onClose]);
  return (
    <div className="menu album-menu" tabIndex={0} ref={menuRef}>
      {printing.pending && (
        <span className="label-print-status" role="status">
          Generating label...
        </span>
      )}
      <IconButton
        type="button"
        className="menu-toggle"
        onClick={(event) => {
          setAnchor(event.currentTarget);
          onToggle(event);
        }}
        aria-label="Album options"
        aria-expanded={open}
        disabled={disabled}
        aria-haspopup="menu"
      >
        <MoreVertIcon />
      </IconButton>
      {open && (
        <MenuSurface
          anchorEl={anchor}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          fitBelow
          onClose={onClose}
        >
          {bulkEditAction}
          {canPrintLabel && (
            <MenuItem
              component="button"
              disabled={printing.pending}
              onClick={() => {
                onClose();
                printing.show();
              }}
            >
              Print Label
            </MenuItem>
          )}
          {children}
        </MenuSurface>
      )}
      <SleeveLabelPrinting albumId={albumId} printing={printing} />
    </div>
  );
}
